import { render } from "./ViewLivraisonPage.vue?vue&type=template&id=136c5087&ts=true"
import script from "./ViewLivraisonPage.vue?vue&type=script&lang=ts"
export * from "./ViewLivraisonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__